import { SmartSendItemGroup } from '../../components/smartsend/item/SmartSendGroup';
export const KeyedSmartSendGroupCache: Record<string, SmartSendItemGroup[]> = {};
